import Vue from "vue";

import axios from "axios";
import qs from "qs";
import { getCookie } from '@util/cookie';

const CODE_MAPPING = {
  query_limit: 429429 // 限流提示code
};

axios.interceptors.request.use(function (config) {
  // previousAjaxTimeStamp 字段在 NavBar 轮询紧急推送消息处使用
  window.previousAjaxTimeStamp = +new Date();
  return config;
});

axios.interceptors.response.use(function (response) {
  let resUrl = response.request.responseURL;
  if (resUrl && resUrl.indexOf('zeus-hq-web') !== -1 && response.data.code && response.data.code === CODE_MAPPING.query_limit) {
    // 报表添加限流提示
    global.vm.$message.error('您的操作过于频繁，请稍后再试');
  }
  if (response.data.indexOf && response.data.indexOf('用户登录') !== -1) {
    window.location.href = '/hq-web/login';
  }
  return response.data;
}, function (error) {
  // 请求拦截白名单  aliyun的接口不做拦截
  const checkWhiteList = (url) => {
    const whiteList = ['aliyuncs.com'];
    url = url || '';
    return whiteList.some(item => url.includes(item));
  };
  if (error && error.response && error.response.request && checkWhiteList(error.response.request.url)) {
    return Promise.reject(error);
  }
  if (!error.response || error.response.status === 401) {
    window.location.href = '/hq-web/login';
  }
  return Promise.reject(error);
});

Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;



// WEBPACK FOOTER //
// ./src/components/core/registerAjax.js